import React from 'react';
import PropTypes from 'prop-types';
import { StickySearch } from 'components/search/StickySearch';
import { JumpNav } from '../../plp/JumpNav/JumpNav';
import { Container } from 'components/core/Page';
import useScrollVisibility from 'hooks/useScrollVisibility';

import './StickyBar.scss';

export function StickyBar({ activeLink, handleLinkClick, handleSearch }) {
	const isVisible = useScrollVisibility(300);

	return (
		<div
			className={`sticky-compo ${isVisible ? 'visible' : ''}`}
			aria-hidden={!isVisible}
		>
			<StickySearch
				sticky
				horizontal
				onSearch={handleSearch}
			/>
			<div className="jump-nav">
				<Container>
					<JumpNav
						activeLink={activeLink}
						handleLinkClick={handleLinkClick}
					/>
				</Container>
			</div>
		</div>
	);
}

StickyBar.propTypes = {
	activeLink: PropTypes.string,
	handleLinkClick: PropTypes.func.isRequired,
	handleSearch: PropTypes.func.isRequired,
};

export default StickyBar;
